import React, { useState, useEffect, useLayoutEffect, useRef, useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { createChatSocket } from "../../utils/chatSocket";
import "./ChatApp.modules.css";
import { useChatSocket } from "../../contexts/ChatSocketContext";
import { Box, Typography } from "@mui/material";
import axios from "axios";
import Switch from '@mui/material/Switch';
import { grey, orange, yellow } from "@mui/material/colors";
import RefreshIcon from "@mui/icons-material/Refresh";
import LaunchIcon from "@mui/icons-material/Launch";
import IconButton from "@mui/material/IconButton";
import FileUpload from "./Fileuplad"; //채팅 & 공지사항 파일업로드 컴포넌트
import UploadIcon from '@mui/icons-material/Upload';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useOneEffect } from "../useOneEffect";

const ticonNotice = {
  color: "white",
  fontSize: "1.5rem",
  marginLeft: "0.2rem",
  cursor: "pointer",
  backgroundColor: yellow[800], // 공지사항
  borderRadius: "50%",
};

const ticonChat = {
  color: "white",
  fontSize: "1.5rem",
  marginLeft: "0.2rem",
  cursor: "pointer",
  backgroundColor: grey[500], // 동원대화방
  borderRadius: "50%",
};

const ticonSupport = {
  color: "white",
  fontSize: "1.5rem",
  marginLeft: "0.2rem",
  cursor: "pointer",
  backgroundColor: orange[800], // 자원대화방
  borderRadius: "50%",
};

const ficon = {
  color: "white",
  fontSize: "1rem",
  marginLeft: "0",
  paddingLeft: "0",
  cursor: "pointer",
  backgroundColor: orange[300],
  borderRadius: "50%",
};

const panelBaseStyle = {
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  border: "solid 1px black",
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  backgroundColor: "#f5f5dc",
  transition: "max-height 0.4s ease-in-out",
  boxSizing: "border-box", /* 좌측 세로라인 잘림 방지: width에 border 포함 */
};
const headerStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "#e9e284",
  padding: "0 8px",
  fontWeight: "bold",
  height: "53px",
  minHeight: "53px",
  maxHeight: "53px",
  boxSizing: "border-box",
  borderRadius: "3px 3px 0 0",
  fontSize: "1.25rem",
  margin: 0,
  lineHeight: 1.2,
  overflow: "hidden",
};
// 공지사항 축소 시: 기존 배경(#e9e284) 유지, 컴팩트 패딩
const headerStyleCompactBrd = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "#e9e284",
  padding: "4px 10px",
  marginBottom: 0,
  marginTop: 0,
  height: 36,
  minHeight: 36,
  fontWeight: "bold",
  borderRadius: "3px 3px 0 0",
  boxSizing: "border-box",
  fontSize: "1.25rem",
};
// 채팅 축소 시: 기존 배경(#a9bdce) 유지, 컴팩트 패딩
const headerStyleCompactChat = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "#a9bdce",
  padding: "4px 10px",
  marginBottom: 0,
  marginTop: 0,
  height: 36,
  minHeight: 36,
  fontWeight: "bold",
  borderRadius: "3px 3px 0 0",
  boxSizing: "border-box",
  fontSize: "1.25rem",
};
const switchstyle = {
  backgroundColor: grey[200],
  marginRight: 1,
  marginLeft: 1,
  borderRadius: 3,
};


function ChatApp(props) { 
  const location = useLocation();
  const qrs = location.search;
  const params = new URLSearchParams(qrs);
  // console.log(params.size)
  const csort = params.size == 0; // 0: 메인프로그램, 1: 동원자원앱
  //console.log(csort)
  //const hqox = sessionStorage.loginOrg // 로그인 조직 구분
  let ondsid = (sessionStorage.ondsid || "").trim();

  const socketFromContext = useChatSocket();
  const socketRef = useRef(null);
  const socketOwnedRef = useRef(false);

  let socket;
  if (socketFromContext) {
    socket = socketFromContext;
  } else {
    if (!socketRef.current) {
      socketRef.current = createChatSocket();
      socketOwnedRef.current = true;
    }
    socket = socketRef.current;
  }

  const visiblePanels = props.visiblePanels; // 단독창: ['brd'] | ['chat'] | ['support'] 등 선택한 패널만
  const [reloadbrd, setReloadbrd] = useState(""); // 공지사항 재로딩
  const [reloadchat, setReloadchat] = useState(""); // 채팅 재로딩
  const [viewbrd, setViewbrd] = useState(() => (visiblePanels ? visiblePanels.includes("brd") : true)); // 공지사항 보기/숨기기
  const [viewchat, setViewchat] = useState(() => (visiblePanels ? visiblePanels.includes("chat") : true)); // 채팅창 보기/숨기기
  const [viewSupportChat, setViewSupportChat] = useState(() => (visiblePanels ? visiblePanels.includes("support") : true)); // 지원인력 대화방 보기/숨기기
  const [reloadSupportChat, setReloadSupportChat] = useState("");
  const [supportChatMessages, setSupportChatMessages] = useState([]);
  const supportInputRef = useRef(null);
  const supportListRef = useRef(null);
  const CSORT_SUPPORT = 2;

  let wheight = window.innerHeight - 100;

  useEffect(() => { // 채팅 데이터 수신 처리
    const handler = (data) => {
      const sid = (sessionStorage.ondsid || "").trim();
      if(sessionStorage.ChatPanel == "false"){return} // 채팅창 보기가 꺼져있으면 중지
      const { name, msg, time, dsid, time2, filename} = data;
      if(dsid != sid){return};
      // 이중전송방지를 위하여 변수
      if(sessionStorage.beforeData == undefined){sessionStorage.beforeData = "name^msg^time^dsid"};
      // // 이중전송방지를 위하여 이전데이터와 비교하여 동일하면 중지
      if(sessionStorage.beforeData == name+"^"+msg+"^"+dsid+"^"+time2){return};
      const item = new LiModel(name, msg, time, filename);
      item.makeLi();
      const displayContainer = document.querySelector(".display-container");
      if (displayContainer) displayContainer.scrollTo(0, displayContainer.scrollHeight);
      sessionStorage.beforeData = name+"^"+msg+"^"+dsid+"^"+time2;
    };
    socket.on("chatting", handler);
    return () => socket.off("chatting", handler);
  }, []);

  useEffect(() => { // 공지사항 데이터 수신 처리
    const handler = (data) => {
      if(sessionStorage.BrdPanel == "false"){return} // 채팅창 보기가 꺼져있으면 중지
      setReloadbrd(+new Date());
    };
    socket.on("brd", handler);
    return () => socket.off("brd", handler);
  }, []);

  useEffect(() => { // 지원인력 대화방 수신
    const handler = (data) => {
      const sid = (sessionStorage.ondsid || "").trim();
      if (data.dsid !== sid) return;
      setSupportChatMessages((prev) => [
        ...prev,
        { name: data.name, msg: data.msg, time: data.time || "", time2: data.time2 || 0, filename: data.filename || "" },
      ]);
    };
    socket.on("chatting_support", handler);
    return () => socket.off("chatting_support", handler);
  }, []);

  useEffect(() => {
    return () => {
      if (socketOwnedRef.current && socketRef.current) {
        socketRef.current.off("chatting");
        socketRef.current.off("brd");
        socketRef.current.off("chatting_support");
        socketRef.current.disconnect();
      }
    };
  }, []);

  
  const delbrd = (e) => { //공지게시판 항목삭제
    if(!window.confirm("삭제하시겠습니까")){return}
    const sendDelbrd = async () => { 
      const snum = e.target.value
      const wstring = `${props.apiAddr}/get/delbrdmsg?dsid=${ondsid}&snum=${snum}`;
      const response = await axios.get(wstring);
      const result = response.data.result;
      if(result == 'success'){
        setReloadbrd(+new Date());
        socket.emit("brd");
      }else{
        alert("삭제에 실패했습니다. 잠시후 다시 시도해주세요")
      }
    }
    sendDelbrd()
  }

  useEffect(() => {// 공지사항 데이터 수신 처리
    const getbrdmsg = async () => {
      const wstring = `${props.apiAddr}/get/getbrdmsg?dsid=${ondsid}`;
      const response = await axios.get(wstring);
      const responseData = response.data;
      //console.log(responseData);

      if(viewbrd == false){return} // 공지사항 보기가 꺼져있으면 중지
      const brdlist = document.querySelector(".brd-list");
      if (brdlist) brdlist.innerHTML = "";
      // brdlist.innerHTML = "";
      responseData.map((item) => {
        // item.cipdt 값을 const tvalue에 yy.mm.dd hh:mm:ss 형식으로 저장
        const tvalue = item.cipdt.substring(2, 16).replace("T", " ");
        const btn = document.createElement("button");
        btn.classList.add("accordion");
        const sp1 = document.createElement("span");
        sp1.classList.add("brd-item-title");
        sp1.innerHTML = item.ctitle;
        const sp2 = document.createElement("span");
        sp2.classList.add("brd-item-date");
        sp2.innerHTML = tvalue;
        btn.appendChild(sp1);
        btn.appendChild(sp2);

        // btn.innerHTML = `<span>${item.ctitle}</span><span className="brd-item-date">${tvalue}</span>`;
        let fnm, filepath;
        fnm = item.cfilename.trim();
        if(fnm == "undefined"){
          fnm = "";
        }else{
          fnm = item.cfilename.trim();
          filepath = `https://mfm.119survey.org/uploads/${fnm}` // 파일경로
        }
        const div = document.createElement("div");
        div.classList.add("panel");
        // fnm의 확장자 추출
        const filexe = fnm.split(".")[1];
        if(filexe == "jpg" || filexe == "png" || filexe == "gif" || filexe == "jpeg" || filexe == "bmp"){
          // div.innerHTML = `<p>${item.cmsg}</p><p><img src='${filepath}' width=200 height=200 ></p>`;
          const p1 = document.createElement("p");
          const p2 = document.createElement("p");
          const img = document.createElement("img");
          img.src = filepath;
          img.width = 200;
          img.height = 200;
          img.addEventListener("click", function() {
            openImage(filepath);
          });
          p1.innerHTML = item.cmsg;
          p2.appendChild(img);
          div.appendChild(p1);
          div.appendChild(p2);

        }else{
          div.innerHTML = `<p>${item.cmsg}</p><p><a href=${filepath}>${fnm}</a></p>`;
        }
        const sp3 = document.createElement("button");
        sp3.classList.add("brd-item-del");
        sp3.innerHTML = "삭제";
        sp3.value = item.snum;
        sp3.addEventListener("click", delbrd);
        csort && div.appendChild(sp3);

        btn.addEventListener("click", function() {
          this.classList.toggle("active");
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
          // 선택한거 외에는 모두 닫기 기능 추가
          var acc = document.getElementsByClassName("accordion");
          for (var i = 0; i < acc.length; i++) {
            if(acc[i] != this){
              acc[i].classList.remove("active");
              var panel = acc[i].nextElementSibling;
              panel.style.maxHeight = null;
            }
          }
        });
        if (brdlist) brdlist.appendChild(btn);
        if (brdlist) brdlist.appendChild(div);
      });
    }
    // getbrdmsg()
    setTimeout(() => {
      getbrdmsg()
    }, 1000);
  }
  , [reloadbrd, props.refreshBrd]);

  const imgview = (path) => {
    alert(path)
    // window.open(path, "imgview", "width=500, height=500, toolbar=no, menubar=no, scrollbars=no, resizable=yes");

  }

  function openImage(filepath) {
    // 이미지를 새 창에서 열도록 하는 로직을 추가
    window.open(filepath, '_blank');
  }

  useEffect(() => { // DB로부터 받은 채팅데이터 수신 처리
    if(sessionStorage.rprops < props.refreshChat){
      sessionStorage.removeItem("latesnum");
      sessionStorage.removeItem("chat_oldestsnum");
      chatHasMoreRef.current = false;
      setChatHasMore(false);
      const chatList = chatListRef.current;
      if (chatList) chatList.innerHTML = "";
    }
    sessionStorage.rprops = props.refreshChat;

    const getchatmsg = async () => {
      if(sessionStorage.latesnum == undefined){sessionStorage.latesnum = 0}
      const latesnum = parseInt(sessionStorage.latesnum) || 0;
      const wstring = `${props.apiAddr}/get/getchatmsg?dsid=${ondsid}&latesnum=${latesnum}`;
      const response = await axios.get(wstring);
      let responseData = response.data;

      if(viewchat == false){return}
      const chatList = chatListRef.current;
      if (!chatList) { console.warn("채팅 리스트 요소를 찾을 수 없습니다."); return; }
      if(chatList.childElementCount == 0){ chatList.innerHTML = ""; }

      if (latesnum === 0 && responseData.length > 0) {
        // 초기 로딩: 백엔드가 DESC 반환 → 역순으로 표시 (오래된 것이 위)
        responseData = [...responseData].reverse();
        sessionStorage.chat_oldestsnum = responseData[0].snum;
        chatHasMoreRef.current = responseData.length >= 20;
        setChatHasMore(responseData.length >= 20);
      }

      responseData.forEach((item) => {
        const li = buildChatLi(item);
        chatList.appendChild(li);
      });

      const displayContainer = displayContainerRef.current;
      if (displayContainer) displayContainer.scrollTo(0, displayContainer.scrollHeight);
      if(responseData.length > 0){
        sessionStorage.latesnum = responseData[responseData.length - 1].snum;
      }
    }
    getchatmsg()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadchat, props.refreshChat]);

  const btinputRef = useRef(); // 공지사항 제목(title) 데이터
  const bminputRef = useRef(); // 공지사항 본분(msg) 데이터
  const bfinputRef = useRef(); // 공지사항 파일첨부(file) 데이터
  const inputRef = useRef(); // 채팅 입력데이터
  const nameRef = useRef(); // 동원자원 대화방 대화명 입력데이터
  const supportNameRef = useRef(); // 지원인력 대화방 대화명 입력데이터
  const [supportFilename, setSupportFilename] = useState(""); // 지원인력 대화방 파일첨부 파일명

  // 동원자원 무한스크롤 refs & state
  const displayContainerRef = useRef(null);
  const chatListRef = useRef(null);
  const chatHasMoreRef = useRef(false);
  const chatLoadingMoreRef = useRef(false);
  const [chatHasMore, setChatHasMore] = useState(false);
  const [chatLoadingMore, setChatLoadingMore] = useState(false);

  // 지원인력 무한스크롤 refs & state
  const supportHasMoreRef = useRef(false);
  const supportLoadingMoreRef = useRef(false);
  const supportOldestSnumRef = useRef(null);
  const supportScrollRestoreRef = useRef(null);
  const [supportHasMore, setSupportHasMore] = useState(false);
  const [supportLoadingMore, setSupportLoadingMore] = useState(false);

  // DOM 채팅 li 생성 헬퍼 (동원자원 대화방 DOM-based 공통)
  const buildChatLi = useCallback((item) => {
    let tvalue = item.cipdt ? item.cipdt.substring(11, 16) : (item.time || "");
    if (tvalue.length === 5) tvalue = tvalue > "12:00" ? tvalue + " PM" : tvalue + " AM";
    const li = document.createElement("li");
    const cname = (item.cname || item.name || "").trim();
    const on = cname.split(" ");
    const name_org = on[0] || "";
    const name_name = on.slice(1).join(" ") || "";
    const selfName = (nameRef.current?.value || "").trim();
    li.classList.add(selfName === cname ? "sent" : "received");
    const fn = (item.cfilename || item.filename || "").trim();
    const filexe = fn.includes(".") ? fn.split(".").pop().toLowerCase() : "";
    const filepath = fn ? `https://mfm.119survey.org/uploads/${fn}` : "";
    const msg = item.cmsg || item.msg || "";
    if (!fn || fn === "undefined") {
      li.innerHTML = `<span class="profile"><span class="user_org">${name_org}</span><span class="user">${name_name}</span></span><span class="message">${msg}</span><span class="time">${tvalue}</span>`;
    } else if (["jpg","jpeg","png","gif","bmp"].includes(filexe)) {
      li.innerHTML = `<span class="profile"><span class="user_org">${name_org}</span><span class="user">${name_name}</span><img src='${filepath}' width=100 height=100></span><span class="message">${msg}</span><span class="time">${tvalue}</span>`;
      li.addEventListener("click", () => window.open(filepath, "_blank"));
    } else if (filexe === "mp4") {
      li.innerHTML = `<span class="profile"><span class="user_org">${name_org}</span><span class="user">${name_name}</span><video src='${filepath}' width=100 height=100></span><span class="message">${msg}</span><span class="time">${tvalue}</span>`;
      li.addEventListener("click", () => window.open(filepath, "_blank"));
    } else {
      li.innerHTML = `<span class="profile"><span class="user_org">${name_org}</span><span class="user">${name_name}</span></span><span class="message"><a href=${filepath}>${msg || fn}</a></span><span class="time">${tvalue}</span>`;
    }
    return li;
  }, []);

  const mapSupportMsg = (r) => ({
    name: r.cname || "",
    msg: r.cmsg || "",
    time: r.cipdt ? new Date(r.cipdt).toLocaleTimeString("ko-KR", { hour: "2-digit", minute: "2-digit", hour12: true }) : "",
    time2: r.snum || 0,
    filename: r.cfilename || "",
  });

  useEffect(() => {
    const loadSupportChat = async () => {
      const sid = (sessionStorage.ondsid || "").trim();
      if (!sid || !props.apiAddr || !viewSupportChat) return;
      try {
        const res = await axios.get(
          `${props.apiAddr}/get/getchatmsg?dsid=${encodeURIComponent(sid)}&latesnum=0&csort=${CSORT_SUPPORT}`
        );
        // 백엔드가 DESC(최신순) 반환 → 역순으로 표시 (오래된 것이 위)
        const rawList = (Array.isArray(res.data) ? res.data : []).reverse();
        supportOldestSnumRef.current = rawList.length > 0 ? rawList[0].snum : null;
        const hasMore = rawList.length >= 20;
        supportHasMoreRef.current = hasMore;
        setSupportHasMore(hasMore);
        setSupportChatMessages(rawList.map(mapSupportMsg));
      } catch (e) {
        console.error(e);
      }
    };
    loadSupportChat();
  }, [reloadSupportChat, viewSupportChat, props.apiAddr, props.refreshChat]);

  // 지원인력: 이전 메시지 20건 로드 (무한스크롤)
  const loadMoreSupportChat = useCallback(async () => {
    if (supportLoadingMoreRef.current || !supportHasMoreRef.current || !supportOldestSnumRef.current) return;
    const sid = (sessionStorage.ondsid || "").trim();
    if (!sid || !props.apiAddr) return;

    supportLoadingMoreRef.current = true;
    setSupportLoadingMore(true);
    const el = supportListRef.current;
    if (el) {
      supportScrollRestoreRef.current = { prevScrollHeight: el.scrollHeight, prevScrollTop: el.scrollTop };
    }

    try {
      const res = await axios.get(
        `${props.apiAddr}/get/getchatmsg?dsid=${encodeURIComponent(sid)}&beforesnum=${supportOldestSnumRef.current}&csort=${CSORT_SUPPORT}`
      );
      const data = Array.isArray(res.data) ? res.data : [];

      if (data.length === 0) {
        supportHasMoreRef.current = false;
        setSupportHasMore(false);
        supportScrollRestoreRef.current = null;
        return;
      }

      // DESC → 역순 (오래된 것이 위)
      const reversed = [...data].reverse();
      supportOldestSnumRef.current = reversed[0].snum;
      setSupportChatMessages(prev => [...reversed.map(mapSupportMsg), ...prev]);
      if (data.length < 20) {
        supportHasMoreRef.current = false;
        setSupportHasMore(false);
      }
    } catch(e) {
      console.error(e);
      supportScrollRestoreRef.current = null;
    } finally {
      supportLoadingMoreRef.current = false;
      setSupportLoadingMore(false);
    }
  }, [props.apiAddr]);

  // 지원인력: 메시지 변경 시 스크롤 처리 (새 메시지 → 맨 아래, prepend → 위치 복원)
  useLayoutEffect(() => {
    const el = supportListRef.current;
    if (!el) return;
    const restore = supportScrollRestoreRef.current;
    if (restore) {
      supportScrollRestoreRef.current = null;
      el.scrollTop = el.scrollHeight - restore.prevScrollHeight + restore.prevScrollTop;
      return;
    }
    el.scrollTop = el.scrollHeight;
  }, [supportChatMessages]);

  // 지원인력: 스크롤 최상단 감지 → 이전 메시지 로드
  useEffect(() => {
    const el = supportListRef.current;
    if (!el) return;
    const handleScroll = () => {
      if (el.scrollTop < 80) loadMoreSupportChat();
    };
    el.addEventListener("scroll", handleScroll, { passive: true });
    return () => el.removeEventListener("scroll", handleScroll);
  }, [loadMoreSupportChat]);

  const sendSupportChat = () => {
    if (sessionStorage.fileSendOx === "true" && sessionStorage.inputedFileSort === "sf") {
      getloc();
      if (!window.confirm("파일을 전송하시겠습니까?")) return;
      supportSendBtnClickHandler();
      const fn = (supportFilename || "").trim();
      const displayName = supportNameRef.current?.value?.trim() || "지원인력관리";
      const param = {
        name: displayName,
        msg: fn || "(파일)",
        dsid: ondsid,
        msgsort: CSORT_SUPPORT,
        filename: fn,
        title: "",
        lat: sessionStorage.glat || "",
        lon: sessionStorage.glon || "",
      };
      socket.emit("chatting_support", { name: param.name, msg: param.msg, dsid: param.dsid, msgsort: param.msgsort, filename: param.filename });
      axios.post(`${props.apiAddr}/post/inputchatmsg`, param).catch((e) => console.error(e));
      if (supportInputRef.current) supportInputRef.current.value = "";
      setSupportFilename("");
      sessionStorage.fileSendOx = "false";
      return;
    }
    const msg = supportInputRef.current?.value?.trim();
    if (!msg || !ondsid || !props.apiAddr) return;
    const displayName = supportNameRef.current?.value?.trim() || "지원인력관리";
    const param = {
      name: displayName,
      msg,
      dsid: ondsid,
      msgsort: CSORT_SUPPORT,
      filename: "",
      title: "",
      lat: "",
      lon: "",
    };
    socket.emit("chatting_support", { name: param.name, msg: param.msg, dsid: param.dsid, msgsort: param.msgsort, filename: param.filename });
    axios.post(`${props.apiAddr}/post/inputchatmsg`, param).catch((e) => console.error(e));
    supportInputRef.current.value = "";
    /* 메시지는 서버 브로드캐스트(chatting_support 수신)로만 추가. 낙관적 추가 시 수신과 중복되어 두 번 보이므로 제거 */
  };
  
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      send();
    }
  };

  const getloc = () => {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    function success(pos) {
      const crd = pos.coords;
      sessionStorage.glat = crd.latitude;
      sessionStorage.glon = crd.longitude;
      sessionStorage.gacc = crd.accuracy;
      sessionStorage.gtme = new Date().toISOString().slice(0, 19).replace(/-/g, "").replace(/:/g, "").replace("T", "");
    }
    function error(err) {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }
    navigator.geolocation.getCurrentPosition(success, error, options);
  }

  function sendChattoDB(param) { // 채팅(공지) 데이터 DB입력
    const inputchatmsg = async () => {
      // 동원력 DB입력
      const wstring = `${props.apiAddr}/post/inputchatmsg`;
      // console.log(wstring);
      const response = await axios.post(wstring,param);
      const result = response.data.result;
      // console.log(result);
      if (result == "success") {
        setReloadbrd(+new Date());
        sessionStorage.filename = ""; // 파일명 초기화
      }
    }
    setTimeout(() => {
      inputchatmsg()
    }
    , 1000);
  }

  const send = () => { // 채팅 데이터 실시간 전송 처리
    if(sessionStorage.fileSendOx == "true") { // 파일전송중이면 파일전송기능으로 변경
      getloc(); // 위치정보 획득
      if(window.confirm("파일을 전송하시겠습니까?")){
        sendBtnClickHandler(); // 파일전송기능 호출
      }else{
        inputRef.current.value = ""; // 채팅 입력데이터 초기화
      }
      sessionStorage.fileSendOx = "false"; // 파일전송중이 아니도록 변경
      // return;
    }

    if(inputRef.current.value==""){return}
    const param = {
      name: nameRef.current.value,
      msg: inputRef.current.value,
      filename: sessionStorage.filename != null ? sessionStorage.filename : "",
      dsid: ondsid,
      lat: sessionStorage.glat,
      lon: sessionStorage.glon,
      msgsort: 1, // 0:공지, 1:채팅
    };
    socket.emit("chatting", param);
    inputRef.current.value = ""; // 채팅 입력데이터 초기화
    inputRef.current.focus();
    sendChattoDB(param);
  };

  const syncphoto = () => { // 채팅창 사진 동기화 소켄서버로 보내기
    const param = {
      dsid: ondsid,
    };
    socket.emit("syncphoto", param);
  }

  function LiModel(name, msg, time, filename){
    let narr = name.split(" ");
    let name_org = narr[0];
    let name_name= narr[1];
    this.name = name;
    // console.log(this.name + " : " + nameRef.current.value);
    this.msg = msg;
    this.time = time;
    if(filename == undefined){filename = ""}
    this.filename = filename;
  
    this.makeLi = () => { // 수신 채팅메시지 만들기
      if(sessionStorage.ChatPanel == "false"){return} // 채팅창 보기가 꺼져있으면 중지
      const chatList = document.querySelector(".chatting-list");
      if (!chatList) return;
      const li = document.createElement("li");
      li.classList.add(nameRef.current.value == this.name ? "sent" : "received");

      const fn = this.filename.trim(); // 파일명
      const filexe = fn.split(".")[1]; // 파일확장자 획득
      const filepath = `https://mfm.119survey.org/uploads/${fn}` // 파일경로
      
      if(fn == "undefined" || fn == ""){ // 파일이 없으면 일반메시지로 출력
        const dom = 
          `<span class="profile">
            <span class="user_org">${name_org}</span>
            <span class="user">${name_name}</span>
          </span>
          <span class="message">${this.msg}</span>
          <span class="time">${this.time}</span>`
        li.innerHTML = dom;
      }else{
        // 파일종류가 이미지이면 이미지로 출력
        if(filexe == "jpg" || filexe == "png" || filexe == "gif" || filexe == "jpeg" || filexe == "bmp"){
          const dom = `
          <span class="profile">
            <span class="user_org">${name_org}</span>
            <span class="user">${name_name}</span>
            <img src='${filepath}' width=100 >
          </span>
          <span class="message">${this.msg}</span>
          <span class="time">${this.time}</span>`
          li.addEventListener("click", function() {
            openImage(filepath);
          });
          setTimeout(() => {
            li.innerHTML = dom;  
            const displayContainer = document.querySelector(".display-container");
            if (displayContainer) displayContainer.scrollTo(0, displayContainer.scrollHeight);
            syncphoto()
          }, 1000);
        }else if(filexe == 'mp4'){
          const dom = `
          <span class="profile">
            <span class="user_org">${name_org}</span>
            <span class="user">${name_name}</span>
            <video src='${filepath}' width=100 >
          </span>
          <span class="message">${this.msg}</span>
          <span class="time">${this.time}</span>`
          li.addEventListener("click", function() {
            openImage(filepath);
          });
          li.innerHTML = dom;
        }else{ // 파일종류가 이미지가 아니면 파일명으로 출력
          const dom = 
          `<span class="profile">
            <span class="user_org">${name_org}</span>
            <span class="user">${name_name}</span>
          </span>
          <span class="message"><a href=${filepath}>${this.msg}</a></span>
          <span class="time">${this.time}</span>`
          li.innerHTML = dom;
        }
      }
      chatList.appendChild(li);
    }
  }

  const bsend = () => { // 공지사항 데이티 실시간 전송 처리
    if(sessionStorage.fileSendOx == "true") { // 파일전송중이면 파일전송기능으로 변경
      sendBtnClickHandler(); // 파일전송기능 호출
      sessionStorage.fileSendOx = "false"; // 파일전송중 해제
    }

    const ox = window.confirm("등록하시겠습니까?")
    if(!ox){return}
    if(btinputRef.current.value==""){return}
    const param = {
      name: "관리자",
      title: btinputRef.current.value,
      msg: bminputRef.current.value,
      filename: bfinputRef.current.value,
      dsid: ondsid,
      msgsort: 0,
    };
    socket.emit("brd");
    btinputRef.current.value = ""; // 공지제목 입력초기화
    btinputRef.current.focus();
    bminputRef.current.value = ""; // 공지본문 입력초기화
    bfinputRef.current.value = ""; // 공지파일 입력초기화
    bminputRef.current.focus();
    sendChattoDB(param);
  }

  const brdhandleChange = (e) => {
    // 공지사항 보이기/숨기기
    const ox = e.target.checked;
    // 보이기면 공지데이터 데이터 재로딩
    if (ox) setReloadbrd(+new Date());
    setViewbrd(ox);
    sessionStorage.BrdPanel = e.target.checked;
    //props.hidechat() // 동원자원 목록 숨기기 프롭 호출
  }
  const chathandleChange = (e) => { 
    const ox = e.target.checked;
    sessionStorage.removeItem("latesnum");
    if (ox) setReloadchat(+new Date());
    setViewchat(ox);
    sessionStorage.ChatPanel = e.target.checked;
  }

  useOneEffect(() => { // 공지사항 전체보기/숨기기 프롭처리
    if (visiblePanels) return; // 단독창 모드에서는 visiblePanels 유지
    const ox = props.fullswitch;
    if (ox) setReloadbrd(+new Date());
    setViewbrd(ox);
    sessionStorage.BrdPanel = ox;
    //props.hidechat() // 동원자원 목록 숨기기 프롭 호출
  }, [props.fullswitch, visiblePanels]);

  useOneEffect(() => { // 채팅 전체보기/숨기기 프롭처리
    if (visiblePanels) return; // 단독창 모드에서는 visiblePanels 유지
    const ox = props.fullswitch;
    sessionStorage.removeItem("latesnum");
    if (ox) setReloadchat(+new Date());
    setViewchat(ox);
    sessionStorage.ChatPanel = ox;
  }, [props.fullswitch, visiblePanels]);

  useOneEffect(() => { // 지원인력 대화방 전체보기/숨기기 프롭처리 (상단 전체 OFF 시 함께 적용)
    if (visiblePanels) return;
    const ox = props.fullswitch;
    setViewSupportChat(ox);
    sessionStorage.SupportChatPanel = ox;
  }, [props.fullswitch, visiblePanels]);

  const headerHeightBrd = viewbrd ? "53px" : "36px";
  const headerHeightChat = viewchat ? "53px" : "36px";
  const headerHeightSupport = viewSupportChat ? "53px" : "36px";
  const refreshHandler = () => {
    setReloadbrd(+new Date())
  }

  const crefreshHandler = () => {
    sessionStorage.removeItem("latesnum");
    sessionStorage.removeItem("chat_oldestsnum");
    chatHasMoreRef.current = false;
    chatLoadingMoreRef.current = false;
    setChatHasMore(false);
    const chatList = chatListRef.current;
    if (chatList) chatList.innerHTML = "";
    setReloadchat(+new Date());
  }

  // 동원자원 대화방: 스크롤 위에 닿으면 이전 메시지 20건 로드
  const loadOlderChatMsgs = useCallback(async () => {
    if (chatLoadingMoreRef.current || !chatHasMoreRef.current) return;
    const oldestsnum = sessionStorage.chat_oldestsnum;
    if (!oldestsnum) return;

    chatLoadingMoreRef.current = true;
    setChatLoadingMore(true);
    const el = displayContainerRef.current;
    const prevScrollHeight = el ? el.scrollHeight : 0;

    try {
      const res = await axios.get(
        `${props.apiAddr}/get/getchatmsg?dsid=${ondsid}&beforesnum=${oldestsnum}&csort=1`
      );
      const data = Array.isArray(res.data) ? res.data : [];

      if (data.length === 0) {
        chatHasMoreRef.current = false;
        setChatHasMore(false);
        return;
      }

      const chatList = chatListRef.current;
      if (!chatList) return;

      // 백엔드 DESC → 역순으로 prepend (오래된 것이 위)
      const reversed = [...data].reverse();
      const fragment = document.createDocumentFragment();
      reversed.forEach(item => {
        fragment.appendChild(buildChatLi(item));
      });
      chatList.insertBefore(fragment, chatList.firstChild);

      // 스크롤 위치 복원
      if (el) el.scrollTop = el.scrollHeight - prevScrollHeight;

      sessionStorage.chat_oldestsnum = reversed[0].snum;
      if (data.length < 20) {
        chatHasMoreRef.current = false;
        setChatHasMore(false);
      }
    } catch(e) {
      console.error(e);
    } finally {
      chatLoadingMoreRef.current = false;
      setChatLoadingMore(false);
    }
  }, [props.apiAddr, buildChatLi]);

  const test = () => {
    // sessionStorage.chatmsgs오브젝트형식을 문자열로 변환하여 저장 (개발 시 필요 시 활용)
  }

  // 채팅창 파일입력 호출
  const [inputclicked, setInputclicked] = useState(0);
  const uploadBtnClickHandler = (e) => {
    sessionStorage.inputedFileSort = e.target.id; // 파일입력버튼 구분값 저장
    setInputclicked(+new Date());
  }

  const [sendclicked, setSendclicked] = useState(0);
  const sendBtnClickHandler = () => {
    setSendclicked(+new Date());
  }

  // 지원인력 대화방 파일첨부용 (동원자원과 별도 인스턴스로 단독 창에서도 동작)
  const [supportInputClicked, setSupportInputClicked] = useState(0);
  const supportUploadBtnClickHandler = () => {
    sessionStorage.inputedFileSort = "sf";
    setSupportInputClicked(+new Date());
  };
  const [supportSendClicked, setSupportSendClicked] = useState(0);
  const supportSendBtnClickHandler = () => {
    setSupportSendClicked(+new Date());
  };

  //const [filesendingox, setFilesendingox] = useState(false); // 파일전송중인지 여부
  const inputFilename = (filename) => {
    const sort = sessionStorage.inputedFileSort; // 파일입력버튼 구분값
    if(sort == 'bf') {
      bfinputRef.current.value = filename;
    }
    if(sort == 'cf') {
      inputRef.current.value = filename;
    }
    if(sort == 'sf') {
      setSupportFilename(filename || "");
      if (supportInputRef.current) supportInputRef.current.value = filename || "";
    }
    if (filename === "" && sort === "sf") {
      setSupportFilename("");
      if (supportInputRef.current) supportInputRef.current.value = "";
    }
    filename == "" ? sessionStorage.fileSendOx = false : sessionStorage.fileSendOx = true; // 파일전송중으로 변경(채팅전송버튼이 파일전송기능을수행하도록 변경)
  }
  
  // 패널 비율: 세 개 펼침 2:4:4, 두 개(공지 있음) 3:7, 두 개(공지 없음) 5:5 (메인·앱 공통 적용)
  const expandedCount = (viewbrd ? 1 : 0) + (viewchat ? 1 : 0) + (viewSupportChat ? 1 : 0);
  const useFlexRatio = visiblePanels || csort || expandedCount >= 2; /* 단독창이거나 앱(전체폭)에서 2개 이상 펼치면 비율(전체 채움) 적용 */
  const flexBrd = viewbrd && useFlexRatio
    ? (expandedCount === 3 ? 2 : expandedCount === 2 ? 3 : 1)
    : undefined;
  const flexChat = viewchat && useFlexRatio
    ? (expandedCount === 3 ? 4 : expandedCount === 2 ? (viewbrd ? 7 : 5) : 1)
    : undefined;
  const flexSupport = viewSupportChat && useFlexRatio
    ? (expandedCount === 3 ? 4 : expandedCount === 2 ? (viewbrd ? 7 : 5) : 1)
    : undefined;

  const openStandalone = (panel) => {
    const ondsid = (typeof sessionStorage !== "undefined" && sessionStorage.ondsid) ? sessionStorage.ondsid.trim() : "";
    const chatname = (nameRef.current?.value?.trim()) || (typeof sessionStorage !== "undefined" && sessionStorage.chatname) || "";
    const q = new URLSearchParams();
    if (ondsid) q.set("ondsid", ondsid);
    if (chatname) q.set("chatname", chatname);
    q.set("panel", panel);
    const base = `${window.location.origin}${(window.location.pathname || "/").replace(/\/$/, "")}`;
    const url = `${base}/standalone-chat?${q.toString()}`;
    const availW = typeof window.screen !== "undefined" ? window.screen.availWidth : 1024;
    const availH = typeof window.screen !== "undefined" ? window.screen.availHeight : 768;
    const ratio = 3 / 4;
    let w = Math.min(480, Math.floor(availW * 0.9));
    let h = Math.floor(w / ratio);
    if (h > availH * 0.9) {
      h = Math.floor(availH * 0.9);
      w = Math.floor(h * ratio);
    }
    window.open(url, `gwmfm-chat-${panel}`, `width=${w},height=${h},scrollbars=yes,resizable=yes`);
  };

  const panelWrapperSx = csort ? {
    position: "absolute",
    zIndex: 10,
    top: 70,
    right: 20,
    width: 400,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    height: wheight,
    maxHeight: wheight,
    overflowY: "auto",
    overflowX: "visible",
    alignItems: "flex-end",
    pointerEvents: "none",
  } : {
    position: "relative",
    zIndex: 10,
    width: "100%",
    height: props.fullHeight ? "100%" : (props.height || 400),
    minHeight: props.fullHeight ? 0 : undefined,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    alignItems: "flex-end",
    overflow: "hidden",
    pointerEvents: "none",
  };

  return (
    <Box sx={panelWrapperSx}>
      {/* 공지사항 패널 - 축소 시 기존 배경 유지, 오른쪽 정렬 */}
      {(!visiblePanels || visiblePanels.includes("brd")) && (
      <Box
        className="wrapper"
        sx={{
          pointerEvents: "auto",
          ...panelBaseStyle,
          width: viewbrd ? (csort ? 400 : "100%") : "auto",
          minWidth: viewbrd ? (csort ? 400 : "100%") : "unset",
          ...(flexBrd != null ? { flex: `${flexBrd} 1 0`, minHeight: 0 } : { maxHeight: viewbrd ? (csort ? Math.floor(wheight / 2) : 280) : headerHeightBrd }),
          ...(!viewbrd ? { alignSelf: "flex-end" } : {}),
          ...(flexBrd != null ? { minHeight: viewbrd ? 53 : 36 } : {}),
        }}
      >
        <Box
          sx={{
            height: 40,
            minHeight: 40,
            maxHeight: 40,
            overflow: "hidden",
            flexShrink: 0,
          }}
        >
          <Typography
            variant="h6"
            component="div"
            sx={[viewbrd ? headerStyle : headerStyleCompactBrd, { "&.MuiTypography-root": { margin: 0 } }]}
            style={{ height: "40px", minHeight: "40px", maxHeight: "40px", boxSizing: "border-box", overflow: "hidden" }}
          >
            {viewbrd && <div className="titleLeft"><RefreshIcon sx={ticonNotice} onClick={refreshHandler} /></div>}
            <div style={{ fontSize: "1.25rem" }}>공지사항</div>
            <span style={{ display: "flex", alignItems: "center" }}>
              <Switch checked={viewbrd} onChange={brdhandleChange} sx={{ ...switchstyle, ...(!viewbrd ? { marginLeft: 0.5, marginRight: 0 } : {}) }} size="small" />
            </span>
          </Typography>
        </Box>
        {viewbrd && (
          <>
            <div className="brd-container" style={{ flex: 1, overflowY: "auto" }}>
              <div className="brd-list">
                <button className="accordion"><span>제목</span><span>2023.11.14 15:35:45</span></button>
                <div className="panel"><p>내용 </p></div>
              </div>
            </div>
            {csort && (
              <div className="brd-input-container">
                <span style={{ display: "flex" }}>
                  <div style={{ display: "flex", flexDirection: "column", flex: 8 }}>
                    <input type="text" className="board-input-title" ref={btinputRef} placeholder="제목을 입력하세요" />
                    <textarea className="board-input-msg" ref={bminputRef} placeholder="내용을 입력하세요" />
                    <div className="brd-input-file-container">
                      <AttachFileIcon id="bf" sx={ficon} style={{ marginRight: "10px", border: "1px solid black" }} onClick={uploadBtnClickHandler} />
                      <input type="text" className="board-input-file-msg" ref={bfinputRef} placeholder="파일첨부" />
                    </div>
                  </div>
                  <button className="bsend-button" onClick={bsend}>등록</button>
                </span>
              </div>
            )}
          </>
        )}
      </Box>
      )}

      {/* 채팅 패널 - 축소 시 기존 배경 유지, 오른쪽 정렬 */}
      {(!visiblePanels || visiblePanels.includes("chat")) && (
      <Box
        className="wrapper"
        sx={{
          pointerEvents: "auto",
          ...panelBaseStyle,
          width: viewchat ? (csort ? 400 : "100%") : "auto",
          minWidth: viewchat ? (csort ? 400 : "100%") : "unset",
          ...(flexChat != null ? { flex: `${flexChat} 1 0`, minHeight: 0 } : { maxHeight: viewchat ? (csort ? undefined : 280) : headerHeightChat }),
          ...(!viewchat ? { alignSelf: "flex-end" } : {}),
          ...(flexChat != null ? { minHeight: viewchat ? 53 : 36 } : {}),
        }}
      >
        <div
          className={viewchat ? "user-container" : ""}
          style={
            viewchat
              ? {
                  // borderBottom: "solid 1px black",
                  borderRadius: "3px 3px 0 0",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "0 8px",
                  height: "40px",
                  minHeight: "40px",
                  boxSizing: "border-box",
                  whiteSpace: "normal", // 자동 줄바꿈
                  wordBreak: "break-all", // 긴 단어 줄바꿈
                }
              : {
                  ...headerStyleCompactChat,
                  whiteSpace: "normal", // 자동 줄바꿈
                  wordBreak: "break-all", // 긴 단어 줄바꿈
                }
          }
        >
          {viewchat && <div className="ctitleLeft"><RefreshIcon sx={ticonChat} onClick={crefreshHandler} /></div>}
          <div className="ctitleCenter">
            <label style={{ fontWeight: "bold", fontSize: "1.25rem", whiteSpace: "nowrap", flexShrink: 0 }} onClick={test}>동원자원 대화방</label>
            {viewchat && (
              <input
                type="text"
                className="titleInput"
                ref={nameRef}
                defaultValue={csort ? "본부 통제단" : props.chatname}
              />
            )}
          </div>
          <div className="ctitleRight">
            {!props.hideStandaloneButton && (
              <IconButton size="small" title="동원자원 대화방만 단독 창으로 열기" onClick={() => openStandalone("chat")} sx={{ color: "inherit", p: 0.5 }}>
                <LaunchIcon fontSize="small" />
              </IconButton>
            )}
            <Switch checked={viewchat} onChange={chathandleChange} sx={{ ...switchstyle, ...(!viewchat ? { marginLeft: 0.5, marginRight: 0 } : {}) }} size="small" />
          </div>
        </div>
        {viewchat && (
          <>
            <div
              className="display-container"
              ref={displayContainerRef}
              style={{ flex: 1, overflowY: "auto" }}
              onScroll={() => {
                const el = displayContainerRef.current;
                if (el && el.scrollTop < 80) loadOlderChatMsgs();
              }}
            >
              {chatLoadingMore && (
                <div style={{ textAlign: "center", padding: "6px 0", fontSize: "0.75rem", color: "#888" }}>
                  이전 메시지 불러오는 중…
                </div>
              )}
              {!chatHasMore && (chatListRef.current?.childElementCount > 0) && (
                <div style={{ textAlign: "center", padding: "4px 0", fontSize: "0.7rem", color: "#aaa" }}>
                  모든 메시지를 불러왔습니다
                </div>
              )}
              <ul className="chatting-list" ref={chatListRef} />
            </div>
            <div className="input-container">
              <span>
                <FileUpload
                  apiAddr={props.apiAddr}
                  inputclicked={inputclicked}
                  inputFilename={inputFilename}
                  sendclicked={sendclicked}
                />
                <UploadIcon id="cf" sx={ticonChat} style={{ marginRight: "10px", border: "1px solid black" }} onClick={uploadBtnClickHandler} />
                <input type="text" className="chatting-input" onKeyPress={handleKeyPress} ref={inputRef} />
                <button className="send-button" onClick={send}>전송</button>
              </span>
            </div>
          </>
        )}
      </Box>
      )}

      {/* 지원인력 대화방 패널 - 동원자원 대화방과 동일 디자인, 헤더·바디·말풍선·배지 등 yellow 테마 */}
      {(!visiblePanels || visiblePanels.includes("support")) && (
      <Box
        className="wrapper support-chat-panel"
        sx={{
          pointerEvents: "auto",
          ...panelBaseStyle,
          width: viewSupportChat ? (csort ? 400 : "100%") : "auto",
          minWidth: viewSupportChat ? (csort ? 400 : "100%") : "unset",
          ...(flexSupport != null ? { flex: `${flexSupport} 1 0`, minHeight: 0 } : { maxHeight: viewSupportChat ? (csort ? undefined : 280) : headerHeightSupport }),
          borderColor: "black",
          ...(!viewSupportChat ? { alignSelf: "flex-end" } : {}),
          ...(flexSupport != null ? { minHeight: viewSupportChat ? 53 : 36 } : {}),
        }}
      >
        <div
          className={viewSupportChat ? "user-container" : ""}
          style={
            viewSupportChat
              ? {
                  // borderBottom: "solid 1px black",
                  borderRadius: "3px 3px 0 0",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "0 8px",
                  height: "40px",
                  minHeight: "40px",
                  boxSizing: "border-box",
                  backgroundColor: yellow[800],
                  color: "rgba(0,0,0,0.87)",
                  wordBreak: "break-all",
                  whiteSpace: "pre-line"
                }
              : {
                  ...headerStyleCompactChat,
                  backgroundColor: yellow[800],
                  color: "rgba(0,0,0,0.87)",
                  wordBreak: "break-all",
                  whiteSpace: "pre-line"
                }
          }
        >
          {viewSupportChat && <div className="ctitleLeft"><RefreshIcon sx={ticonSupport} onClick={() => setReloadSupportChat(+new Date())} /></div>}
          <div className="ctitleCenter">
            <label style={{ fontWeight: "bold", fontSize: "1.25rem", whiteSpace: "nowrap", flexShrink: 0 }}>지원인력 대화방</label>
            {viewSupportChat && (
              <input type="text" className="titleInput" ref={supportNameRef} defaultValue="지원인력관리" placeholder="대화명" />
            )}
          </div>
          <div className="ctitleRight">
            {!props.hideStandaloneButton && (
              <IconButton size="small" title="지원인력 대화방만 단독 창으로 열기" onClick={() => openStandalone("support")} sx={{ color: "inherit", p: 0.5 }}><LaunchIcon fontSize="small" /></IconButton>
            )}
            <Switch checked={viewSupportChat} onChange={(e) => setViewSupportChat(e.target.checked)} sx={{ ...switchstyle, ...(!viewSupportChat ? { marginLeft: 0.5, marginRight: 0 } : {}) }} size="small" />
          </div>
        </div>
        {viewSupportChat && (
          <>
            <div className="display-container support-chat-body" ref={supportListRef} style={{ flex: 1, overflowY: "auto" }}>
              {supportLoadingMore && (
                <div style={{ textAlign: "center", padding: "6px 0", fontSize: "0.75rem", color: "#888" }}>
                  이전 메시지 불러오는 중…
                </div>
              )}
              {!supportHasMore && supportChatMessages.length > 0 && (
                <div style={{ textAlign: "center", padding: "4px 0", fontSize: "0.7rem", color: "#aaa" }}>
                  모든 메시지를 불러왔습니다
                </div>
              )}
              <ul className="chatting-list">
                {supportChatMessages.map((m, i) => {
                  const nameParts = (m.name || "").trim().split(/\s+/);
                  const user_org = nameParts[0] || "";
                  const user_name = nameParts.slice(1).join(" ") || nameParts[0] || m.name || "";
                  const supportDisplayName = (supportNameRef.current?.value || "").trim() || "지원인력관리";
                  const isSent = supportDisplayName === (m.name || "").trim();
                  const fn = (m.filename || "").trim();
                  const filepath = fn ? `https://mfm.119survey.org/uploads/${fn}` : "";
                  const fileExt = fn ? (fn.split(".")[1] || "").toLowerCase() : "";
                  const isImage = ["jpg", "jpeg", "png", "gif", "bmp"].includes(fileExt);
                  const isVideo = fileExt === "mp4";
                  return (
                    <li key={i} className={isSent ? "sent" : "received"}>
                      <span className="profile">
                        <span className="user_org">{user_org}</span>
                        <span className="user">{user_name}</span>
                      </span>
                      <span className="message">
                        {m.msg && <span>{m.msg}</span>}
                        {fn && (
                          <>
                            {m.msg && " "}
                            {isImage ? (
                              <img
                                src={filepath}
                                alt={fn}
                                width={100}
                                height={100}
                                style={{ cursor: "pointer", verticalAlign: "middle" }}
                                onClick={() => window.open(filepath, "_blank")}
                              />
                            ) : isVideo ? (
                              <video src={filepath} width={100} height={100} controls onClick={(e) => { e.stopPropagation(); window.open(filepath, "_blank"); }} />
                            ) : (
                              <a href={filepath} target="_blank" rel="noopener noreferrer">{fn}</a>
                            )}
                          </>
                        )}
                      </span>
                      <span className="time">{m.time}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="input-container">
              <span>
                <FileUpload
                  fileInputId="file_support"
                  apiAddr={props.apiAddr}
                  inputclicked={supportInputClicked}
                  inputFilename={(fn) => {
                    setSupportFilename(fn || "");
                    if (supportInputRef.current) supportInputRef.current.value = fn || "";
                    if (fn === "") {
                      if (supportInputRef.current) supportInputRef.current.value = "";
                      sessionStorage.fileSendOx = "false";
                    } else {
                      sessionStorage.fileSendOx = "true";
                    }
                  }}
                  sendclicked={supportSendClicked}
                  sendBtnClickHandler={supportSendBtnClickHandler}
                />
                <UploadIcon aria-label="파일 첨부" sx={ticonSupport} style={{ marginRight: "10px", border: "1px solid black" }} onClick={supportUploadBtnClickHandler} />
                <input
                  type="text"
                  className="chatting-input"
                  ref={supportInputRef}
                  placeholder="메시지 또는 파일 첨부"
                  onKeyDown={(e) => e.key === "Enter" && sendSupportChat()}
                />
                <button className="send-button" onClick={sendSupportChat}>전송</button>
              </span>
            </div>
          </>
        )}
      </Box>
      )}
    </Box>
  );
}

export default ChatApp;
